import { usePlayerIndex, useTheme } from "@annunciate/ui";
import { useEffect, useState } from "react";
export const useMiniplayerHeight = () => {
    const [height, setHeight] = useState(0);
    const playerIndex = usePlayerIndex();
    const { miniplayerHeight } = useTheme();
    useEffect(() => {
        const miniplayerStyleId = 'mini-player-height';
        let style = document.querySelector(`style[id="${miniplayerStyleId}"]`);
        if (!style) {
            style = document.createElement('style');
            style.id = miniplayerStyleId;
        }
        const height = playerIndex === 0 ? miniplayerHeight : 0;
        setHeight(height);
        style.innerHTML = `:root { --mini-player-height: ${height}px; }`;
        document.head.appendChild(style);
    }, [playerIndex, miniplayerHeight]);
    return height;
};
//# sourceMappingURL=useMiniplayerHeight.js.map